import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Footer from '../Shared/Footer/Footer';
import Navigation from '../Shared/Navigation/Navigation';
import VideoPlayer from 'react-video-js-player';
import Poster from '../../../src/images/banner.jpg';
import works from '../../../src/images/works.mp4';
const AboutUs = () => {
    return (
        <div>
            <>
                <Navigation />
                <section id="about-us">

                    <Container>

                        <div className="d-flex justify-content-center mb-4 section-title text-center ">
                            {/* Heading  */}
                            <h1 className="heading">
                                <span>A</span>
                                <span>B</span>
                                <span>O</span>
                                <span>U</span>
                                <span>T</span>
                                <span className="space">{""}</span>
                                <span>U</span>
                                <span>S</span>
                            </h1>
                        </div>

                        <Row className="mb-5">
                            <Col md={6} className="d-flex justify-content-center">
                                <VideoPlayer src={works} poster={Poster} width="720" height="360" className="mt-4" />
                            </Col>
                            <Col md={6} className="d-flex align-items-center">
                                <p className=" p-3">
                                    Language Buddy is an education-based start-up initiative dedicated to providing outstanding Chinese language classes taught in both English & Bengali, designed by qualified teachers from both China and Bangladesh.
                                    In a way, it provides fair and equitable returns for present and future owners and superior value to our users. We specialize in developing and delivering a wide range of Mandarin Chinese language courses, regular homework, test materials, and full-time support from our committed team members for a certain period of time, as well as lifetime access to our language learning community.
                                    Language Buddy aims to create a global community of Chinese language learners where they can help each other.

                                    However, Language Buddy offers much more than just a tutorial platform! We'll also provide interactive quizzes, fun games, recommendations on watching Chinese movies, language tips, blogs on Chinese culture, history, travel, and many more to strengthen language learning.


                                </p>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <Footer></Footer>
            </>

        </div>
    );
};

export default AboutUs;